module.exports = __webpack_public_path__ + "img/dessert.08a1a4f7.svg";